import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
const PagePagination = ({ totalPage, setCurrentPage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { currentPage } = useSelector((state) => state.news);
  return (
    <>
      <div className="mt-2">
        <ReactPaginate
          previousLabel={"prev"}
          nextLabel={"next"}
          breakLabel={".."}
          pageCount={parseInt(totalPage)}
          initialPage={currentPage - 1}
          marginPagesDisplayed={2}
          onPageChange={(e) => {
            navigate(`${location.pathname}?page=${parseInt(e.selected) + 1}`);
            window.scroll({ top: 0, behavior: "auto" });
          }}
          containerClassName={"pagination justify-content-center"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};
export default PagePagination;
